import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, SERVICE_AREAS } from "../data/content";
import { SocialLinks } from "./SocialLinks";

export const Footer = () => (
  <footer className="bg-[#0a0a0a] border-t border-zinc-800" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img src="/logo-white.png" alt="Mason's Mobile Mechanic logo" className="h-28 w-auto" />
          <div className="leading-none">
            <span className="font-heading font-bold text-white text-lg tracking-tight block">MASON'S</span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">Mobile Mechanic</span>
          </div>
        </div>
        <p className="text-zinc-400 text-sm leading-relaxed max-w-sm mb-6">
          Professional mobile auto repair serving the entire Las Vegas Valley.
          We bring the shop to you — home, office, or roadside.
        </p>
        <a
          data-testid="footer-call-button"
          href={PHONE_TEL}
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-semibold text-lg mb-5"
        >
          <Phone className="h-5 w-5" /> {PHONE_DISPLAY}
        </a>
        <SocialLinks />
      </div>

      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-home">Home</Link></li>
          <li><Link to="/services" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-services">All Services</Link></li>
          <li><Link to="/membership" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-membership">Membership</Link></li>
          <li><Link to="/portal" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-portal">Member Portal</Link></li>
          <li><Link to="/contact" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-contact">Request Service</Link></li>
          <li><Link to="/pay" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-pay">Pay Online</Link></li>
          <li><Link to="/terms" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Service</Link></li>
          <li><Link to="/membership-agreement" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-agreement">Membership Agreement</Link></li>
          <li><Link to="/cancellation-policy" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-cancellation">Cancellation Policy</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider flex items-center gap-1.5">
          <MapPin className="h-4 w-4 text-blue-500" /> Service Areas
        </h4>
        <ul className="grid grid-cols-1 gap-2 text-sm" data-testid="footer-service-areas">
          {SERVICE_AREAS.map((area) => (
            <li key={area} className="text-zinc-400">{area}</li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-zinc-800/60">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} Mason's Mobile Mechanic. All rights reserved.</span>
        <span>Serving the Las Vegas Valley, Nevada</span>
      </div>
    </div>
  </footer>
);
